module.exports = __webpack_public_path__ + "img/sly4.da7fcd87.jpg";